import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = {
  style: {"z-index":"99999"},
  class: "position-absolute bg-primary vw-100 vh-100 d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  width: "300",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_SpinnerComponent, { class: "mt-4" })
  ]))
}